<script setup>
import { ref, watch, onMounted } from 'vue';
import { useStore } from '../store.js';
import FormGroup from './FormGroup.vue';

const props = defineProps(['entityType', 'values', 'schema', 'submitText', 'parentMovie']);
const emit = defineEmits(['submit']);
const { store, createMovie, updateMovie } = useStore();
const formData = ref({});

onMounted(() => {
  formData.value = { ...props.values };
});

watch(
  () => props.values,
  (newVal) => {
    formData.value = { ...newVal };
  },
  { deep: true }
);

async function handleSubmit() {
  if (formData.value.id === undefined && props.values && props.values.id) {
    formData.value.id = props.values.id;
  }
  try {
    if (props.entityType === 'movie') {
      if (formData.value.id) {
        await updateMovie(formData.value.id, formData.value);
      } else {
        await createMovie(formData.value);
      }
      emit('submit', formData.value);
    } else {
      // For nested entities, emit the data up to the parent for handling
      emit('submit', formData.value);
    }
  } catch (error) {
    console.error('Form submission error:', error);
  }
}
</script>
<template>
  <form @submit.prevent="handleSubmit">
    <div v-if="schema && schema[entityType] && schema[entityType].fields">
      <FormGroup v-for="field in schema[entityType].fields" :key="field.name" :label="field.label" :for="field.name" :description="field.description">
        <input v-if="field.type !== 'textarea'" v-model="formData[field.name]" :type="field.type" :id="field.name" />
        <textarea v-else v-model="formData[field.name]" :id="field.name" rows="4"></textarea>
      </FormGroup>
    </div>
    <div v-else class="error">ERROR: Cannot find fields for entityType: {{ entityType }}</div>
    <div class="form-actions">
      <button type="submit" :disabled="store.loading">{{ submitText }}</button>
    </div>
  </form>
</template>
